import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationPT from '../i18n/pt/global.json';
import translationEN from '../i18n/en/global.json';
import translationFR from '../i18n/fr/global.json';
import translationES from '../i18n/es/global.json';
import translationIT from '../i18n/it/global.json';
import translationCH from '../i18n/zhCH/global.json';

import './i18n';

const savedLanguage = localStorage.getItem('language') || 'pt';
  
const resources = {
  pt: {translation: translationPT, },
  en: { translation: translationEN,},
  es: { translation: translationES },
  it: { translation: translationIT },
  fr: { translation: translationFR },
  zh: { translation: translationCH },
};

i18n
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Faz a integração com o React
  .init({
    resources,
    lng: savedLanguage, // Carrega o idioma salvo no localStorage
    fallbackLng: 'pt', // Caso não consiga detectar ou salvar, use o português
    detection: {
      order: ['localStorage', 'navigator'], // Ordem de detecção
      caches: ['localStorage'], // Armazena o idioma no localStorage
    },
    interpolation: {
      escapeValue: false, // Evita que o i18n escape valores HTML
    },
  });

export default i18n;